/* global Blockly */
import React from 'react';
import { createDefaultDropdown } from '../../../../../../../utils/defaultWidgets';
import {dropdownIcon} from "./index";

// everything here should be ES5
function defineBlock(context, dropdowns) {

    let dropdownOpts = {};
    dropdowns.forEach(function (widget) {
        if (!widget) return;
        
        dropdownOpts[widget.id] = widget.properties.options.map(function (cb) {
            return [cb.name, cb.id];
        });
    });

    return {
        init: function () {
            let widgetDD = new Blockly.FieldWidgetsDropdown(context,"dropdown", undefined, '- select -');
            this.appendDummyInput("A")
                // .appendField("dropdown")
                .appendField(new Blockly.FieldImage(dropdownIcon, 30, 30, "dropdown icon", null), 'dropdownIcon')
                .appendField(widgetDD, "DD")
                .appendField("is set to")
                .appendField(new Blockly.FieldDropdown([['', '']], undefined, '- select -'), "VALUE");
            widgetDD.setOnChange(this._ddChanged.bind(this));
            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, "Boolean"); // add appropriate checks
            this.setOutputShape(Blockly.OUTPUT_SHAPE_HEXAGONAL);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('\'true\' or \'false\' depending on whether the chosen dropdown widget is set to the specified option.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#dropdowns');
            this._ddChanged(this.getFieldValue("DD"));
        },
        onchange: function() {
            if (this.getField('dropdownIcon') && this.getField('dropdownIcon').imageElement_)
                this.getField('dropdownIcon').setTooltip('DropDown');
        },
        onLoad: function(){
            let id= this.getFieldValue('DD');
            let widget = dropdowns.find(function (x) {return x.id === id});
            let opts;
            if (!widget) {
                console.warn('widget not found: '+id);
                opts = [['','']];
            } else {
                opts = dropdownOpts[id] || [['', '']];
            }

            let dd = this.getField("VALUE");
            let value = dd.getValue();

            if(!opts.filter(function(opt) { return opt[1] === value }).length){
                console.warn('option not found: '+value);
                dd.setToSelectOption();
                dd.setWarning(true);
                let closure = dd.onChange;

                dd.setOnChange(function(){
                    dd.setWarning(false);
                    if(closure){
                        closure();
                        dd.setOnChange(closure);
                    }
                })
            }
        },
        _ddChanged: function (val) {
            let fieldDropDown;
            let input = this.getInput("A");
            input.removeField("VALUE");

            if(this.getField('DD').hasBeenSet){
                fieldDropDown = new Blockly.FieldDropdown(dropdownOpts[val] || [['', '']], undefined, '- select -');
            } else {
                fieldDropDown = new Blockly.FieldDropdown([['', '']], undefined, '- select -');
                fieldDropDown.setEnabled(false);
            }
            input.appendField(fieldDropDown,'VALUE');
            if (this.rendered) {
                this.initSvg();
                this.render();
            }
        }
    }
}

// everything here should be ES5
function defineGenerators(dds) {
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue('DD');
            let val = block.getFieldValue('VALUE');
            let dd = dds.find(function (x) {
                return x?.id === id;
            });
            if (!dd) {
                console.warn('unable to find dropdown with id: ' + id);
                return ['undefined', Blockly.JavaScript.ORDER_NONE];
            }

            let code = "Snap.widgets.dropdown.getValue('" + id + "').value === '" + val + "'";
            code = "(" + code + ")";
            return [code, Blockly.JavaScript.ORDER_NONE]
        }
    }
}

const DropdownIsSetTo = function (props) {
    const name = 'snap_dropdown_is_set_to';
    DropdownIsSetTo.blockName = name;

    let widgets = props.widgets.length > 0 ? props.widgets : [createDefaultDropdown()];

    Blockly.Blocks[name] = defineBlock(props.context, widgets);
    let generators = defineGenerators(widgets);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget && (props.widget.id !== undefined)
                ? <field name='DD'>{props.widget.id}</field>
                : null
            }
        </block>
    );
}

export default DropdownIsSetTo;